// src/pages/FeedbackPage.js
import React, { useEffect, useState } from 'react';
import SurveyList from '../components/SurveyList';
import { apiGet, bootstrapBffSession } from '../lib/apiClient';

export default function FeedbackPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        await bootstrapBffSession().catch(() => {});
        const res = await apiGet('/api/feedback/surveys');
        if (!alive) return;
        const arr = Array.isArray(res?.items) ? res.items : [];
        setItems(arr);
      } catch (e) {
        if (!alive) return;
        setError(e?.message || String(e));
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div className="container" style={{ maxWidth: 900 }}>
      <div className="card" style={{ marginTop: 12 }}>
        <h2 style={{ marginTop: 0 }}>Product Feedback & Suggestions</h2>
        <p style={{ marginBottom: 8 }}>
          Browse community feedback surveys. Vote by responding and liking. Create your own survey and check “product feedback” to have it appear here.
        </p>
      </div>

      {loading && <div className="card">Loading feedback survey…</div>}
      {error && <div className="card error">{error}</div>}
      {!loading && !error && items && items.length > 0 && (
        <SurveyList itemsOverride={items} />
      )}
    </div>
  );
}
